import { ACTIONS } from "@intellectability/platform-common/constants";

/** @type {import("@intellectability/platform-common/router").RouteDefinition[]} */
const systemRoutes = [
    {
        action: ACTIONS.TEST_MODE_PANEL,
        component: () => import("./TestMode/TestModePanel.svelte"),
        title: "Test Mode",
        layout: "popover"
    },
    {
        action: 100300,
        component: () => import("./DevMode/DevModePanel.svelte"),
        title: "Dev Mode",
        layout: "popover"
    }
];

export default systemRoutes;